import {
    SHOW_SUCCESSFUL_MESSAGE,
    SHOW_INFO_MESSAGE,
    SHOW_WARNING_MESSAGE,
    SHOW_ERROR_MESSAGE,
    LOGGED_IN_MESSAGE,
    SCROLL_DASHBOARD_TO_TOP,
    UPDATE_SHOW_LOADING,
    USER_LOGOUT
} from './actionConst';

import Auth from "utils/Auth/Auth";

export const showSuccessfulMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_SUCCESSFUL_MESSAGE,
            payload: message
        }
    );
}

export const showInfoMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_INFO_MESSAGE,
            payload: message
        }
    );
}

export const showWarningMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_WARNING_MESSAGE,
            payload: message
        }
    );
}

export const showErrorMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_ERROR_MESSAGE,
            payload: message
        }
    );
}

export const setLoggedInMessage = (value) => dispatch => {
    dispatch(
        {
            type: LOGGED_IN_MESSAGE,
            payload: value
        }
    );
}

export const scrollDashboardToTop = () => dispatch => {
    dispatch(
        {
            type: SCROLL_DASHBOARD_TO_TOP,
            payload: true
        }
    );
}

export const updateShowLoading = (value) => dispatch => {
    dispatch(
        {
            type: UPDATE_SHOW_LOADING,
            payload: value
        }
    );
}

export const logout = () => dispatch => {
    new Auth().logout();
    dispatch(
        {
            type: USER_LOGOUT,
            payload: {}
        }
    );
}


// WEBPACK FOOTER //
// ./src/reducers/application/applicationActions.js